import _ from 'lodash';
import React from 'react';
import BookingField from './BookingDrawerField.react';

const TravelersField = ({ booking, t, className }) => {
    const roomCount = booking.deal.details.room_count || 1;
    const childrenCount = booking.deal.details.children_count || 0;
    const childrenAges = (booking.deal.details.children_ages || []).map((age) => (age === 0 ? t('underOne') : age));
    const namedTravelers = booking.travelers.filter((tr) => !tr.ghost);
    const ghostCount = booking.travelers.filter((tr) => tr.ghost).length;
    const ghostsPerRoom = ghostCount > 0 ? ghostCount / roomCount : 0;
    const travelersByRoom = _.groupBy(namedTravelers, (tr) => tr.room || 1);
    const totalTravelers =
        booking.travelers.length + (booking.deal.details.children_count || 0) * (booking.deal.details.room_count || 1);

    return (
        <BookingField
            fieldTitle={totalTravelers > 1 ? t('TravelerPluralWithCount', { count: totalTravelers }) : t('Traveler')}
            fieldValue={
                <div>
                    {Object.keys(travelersByRoom).map((roomNum) => {
                        const roomTravelers = travelersByRoom[roomNum];
                        return (
                            <div key={roomNum}>
                                {roomCount > 1 && (
                                    <div>
                                        <strong>
                                            {t('Room')} #{roomNum}
                                        </strong>
                                    </div>
                                )}
                                {roomTravelers.map((traveler, i) => (
                                    <div key={i}>
                                        {traveler.first_name} {traveler.last_name}
                                    </div>
                                ))}
                                {ghostsPerRoom > 0 && (
                                    <div>
                                        +{ghostsPerRoom} {ghostsPerRoom === 1 ? t('Adult') : t('Adults')}
                                    </div>
                                )}
                                {childrenCount > 0 && (
                                    <div>
                                        +{childrenCount} {childrenCount > 1 ? t('Children') : t('Child')} (
                                        {childrenCount === 1 ? t('age') : t('ages')} {childrenAges.join(', ')})
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            }
            className={className}
        />
    );
};

export default TravelersField;
